import axios, { AxiosResponse } from "axios";
import type { AppUserDto } from "../../dto/app-user.dto";
import { UpdateUserDto } from "../../dto/app-user-update.dto.ts";

export function fetchUser(): Promise<AxiosResponse<AppUserDto>> {
  return axios.post("/private/app-user");
}

export function viewedElement(key: string): Promise<AxiosResponse<void>> {
  return axios.post("/app-user/element-viewed", { key });
}

export function changePassword(
  oldPassword: string,
  newPassword1: string,
  newPassword2: string
): Promise<AxiosResponse<void>> {
  return axios.post("/private/app-user/password/change", {
    oldPassword,
    newPassword1,
    newPassword2,
  });
}

export function updateUser(
  updatedValues: UpdateUserDto
): Promise<AxiosResponse<AppUserDto>> {
  const { trackingAccepted = null } = updatedValues;

  return axios.post("/private/app-user/update", {
    trackingAccepted,
  });
}

export function resendCode(): Promise<AxiosResponse<void>> {
  return axios.post("/private/registration-code/resend");
}
